import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { IFormComponent, ItemType } from "../entitybuilder/edit-entity.component";
import { isEmpty} from "../../../common/models/data-manipulation-functions";

@Component({
    templateUrl: "./object-form.component.html",
    standalone: false
})
export class ObjectFormComponent implements IFormComponent, OnInit {
    @Input() title: string;
    @Input() data: any;
    @Input() parent?: string;
    @Input() formComponent: FormGroup;
    @Input() newItem?: boolean
    public itemTypes: Array<ItemType> = [
        { key: "String", value: "string" },
        { key: "Array", value: "array" },
        { key: "Bool", value: "boolean" },
        { key: "Object", value: "object" },
        { key: "Number", value: "number" },
        { key: "Integer", value: "integer" }
    ];

    ngOnInit(): void {
        if (this.title === "items") {
            this.name.disable();
        }

		if (isEmpty(this.data.properties)) {
            this.allowNulls.disable();
        }
    }

    get name() { return this.formComponent.get("name"); }
    get allowNulls() { return this.formComponent.get("allowNulls"); }
    get itemType() { return this.formComponent.get("itemType"); }
}
